import velocity from 'velocity-animate';
import { isMobile, isTabletOrDeskTop } from 'common/visualizations/helpers/MediaQueryHelper';

export default function FlannelFactory() {
  const animationDuration = 300;
  const animationEasing = [0.645, 0.045, 0.355, 1];
  const hoverables = Array.prototype.slice.apply(document.querySelectorAll('[data-flannel]'));
  let lastFocusedItem = null;

  function hideFlannel(flannel, hoverable) {
    if (isMobile()) {
      velocity(flannel, {
        left: window.innerWidth
      }, {
        duration: animationDuration,
        easing: animationEasing,
        complete: function() {
          flannel.classList.add('flannel-hidden');
          hoverable.classList.remove('active');
        }
      });
    } else {
      flannel.classList.add('flannel-hidden');
      hoverable.classList.remove('active');
    }

    // Always remove modal-open because there's no harm
    // and we will avoid an unscrollable state.
    document.body.classList.remove('modal-open');

    const elementToFocus = flannel.children[0] || flannel;
    elementToFocus.removeAttribute('tabindex');
    elementToFocus.style.outline = '';

    // Return focus to the last previously focused on element
    if (lastFocusedItem) {
      lastFocusedItem.focus();
      lastFocusedItem = null;
    }
  }

  function positionFlannel(flannel, hoverable) {
    const arrowHeight = 16;
    let left = 0;
    let top = 0;
    const flannelWidth = flannel.getBoundingClientRect().width;
    const bodyWidth = document.body.offsetWidth; // Without scrollbar

    if (isMobile()) {
      if (!flannel.classList.contains('flannel-hidden')) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }

      flannel.style.left = 0;
      flannel.style.top = 0;
      return;
    }

    const hoverableDimensions = hoverable.getBoundingClientRect();

    left = hoverableDimensions.left + (hoverable.offsetWidth / 2);
    top = hoverableDimensions.top + hoverable.offsetHeight + arrowHeight;

    if (left + flannelWidth > bodyWidth && isTabletOrDeskTop()) {
      flannel.classList.remove('flannel-right');
      flannel.classList.add('flannel-left');
      left -= flannelWidth;
    } else {
      flannel.classList.remove('flannel-left');
      flannel.classList.add('flannel-right');
    }

    flannel.style.left = `${left}px`;
    flannel.style.top = `${top}px`;

    document.body.classList.remove('modal-open');
  }

  hoverables.forEach(function(hoverable) {
    const flannelId = hoverable.getAttribute('data-flannel');
    const flannel = document.querySelector(`#${flannelId}`);
    const dismissals = Array.prototype.slice.apply(
      flannel.querySelectorAll('[data-flannel-dismiss]')
    );

    dismissals.forEach(function(dismissal) {
      dismissal.addEventListener('click', function() {
        hideFlannel(flannel, hoverable);
      });
    });

    hoverable.addEventListener('click', function(event) {
      const windowWidth = window.innerWidth;
      event.preventDefault();
      event.stopPropagation();

      if (isTabletOrDeskTop()) {
        flannel.classList.toggle('flannel-hidden');
        positionFlannel(flannel, hoverable);
      } else {
        flannel.classList.remove('flannel-hidden');
        flannel.style.left = `${windowWidth}px`;
        flannel.style.top = 0;
        document.body.classList.add('modal-open');

        velocity(flannel, {
          left: 0
        }, {
          duration: animationDuration,
          easing: animationEasing
        });
      }

      // Store last focused on element
      lastFocusedItem = document.querySelector(':focus');

      // Shift focus to the flannel
      const elementToFocus = flannel.children[0] || flannel;
      elementToFocus.setAttribute('tabindex', '0');
      elementToFocus.focus();
      elementToFocus.style.outline = 'none';
    });

    const boundPositionFlannel = positionFlannel.bind(null, flannel, hoverable);
    window.addEventListener('scroll', boundPositionFlannel);
    window.addEventListener('wheel', boundPositionFlannel);

    document.body.addEventListener('click', function(event) {
      let node = event.target;

      if (node === hoverable || flannel.classList.contains('flannel-hidden')) {
        return;
      }

      while (node.parentElement) {
        if (node.id === flannelId) {
          return;
        }
        node = node.parentElement;
      }

      hideFlannel(flannel, hoverable);
    });

    document.body.addEventListener('keyup', function(event) {
      const key = event.which || event.keyCode;

      // ESC
      if (key === 27) {
        hideFlannel(flannel, hoverable);
      }
    });

    window.addEventListener('resize', function() {
      if (!flannel.classList.contains('flannel-hidden')) {
        positionFlannel(flannel, hoverable);
      }
    });
  });
}
